import type { IGenre } from "@litres-core/store";

export const LITRES_BASE = "https://www.litres.ru";

export const GENRES: IGenre[] = [
  {
    id: 201583,
    uuid: "8974ae57-db67-11e7-8020-0cc47a545a1e",
    name: "легкое чтение",
    url: "/legkoe-chtenie/",
    arts_count: 252420,

    subgenres: [
      {
        id: 5018,
        uuid: "ed160368-f034-11e5-a511-0cc47a5454c6",
        name: "фэнтези",
        url: "/knigi-fentezi/",
        arts_count: 59462,
      },
      {
        id: 5022,
        uuid: "ed1606a8-f034-11e5-a511-0cc47a5454c6",
        name: "детективы",
        url: "/knigi-detektivy/",
        arts_count: 50155,
      },
      {
        id: 5014,
        uuid: "ed15ffbd-f034-11e5-a511-0cc47a5454c6",
        name: "боевики, остросюжетная литература",
        url: "/knigi-boeviki-ostrosugetnaya/",
        arts_count: 34908,
      },
      {
        id: 5004,
        uuid: "ed15f5d9-f034-11e5-a511-0cc47a5454c6",
        name: "фантастика",
        url: "/knigi-fantastika/",
        arts_count: 69692,
      },
      {
        id: 5005,
        uuid: "ed15f6c1-f034-11e5-a511-0cc47a5454c6",
        name: "любовные романы",
        url: "/knigi-lubovnye-romany/",
        arts_count: 87780,
      },
      {
        id: 5006,
        uuid: "ed15f789-f034-11e5-a511-0cc47a5454c6",
        name: "приключения",
        url: "/knigi-priklucheniya/",
        arts_count: 38984,
      },
      {
        id: 5029,
        uuid: "ed160d1e-f034-11e5-a511-0cc47a5454c6",
        name: "эротика и секс",
        url: "/erotika-seks/",
        arts_count: 33244,
      },
      {
        id: 5013,
        uuid: "ed15fe5a-f034-11e5-a511-0cc47a5454c6",
        name: "юмористическая литература",
        url: "/knigi-umor/",
        arts_count: 14838,
      },
      {
        id: 201671,
        uuid: "8977df6e-db67-11e7-8020-0cc47a545a1e",
        name: "классика жанра",
        url: "/legkoe-chtenie/klassika-zhanra/",
        arts_count: 5364,
      },
      {
        id: 201926,
        uuid: "03c4a247-df19-11e7-b9d3-0cc47a5453d6",
        name: "легкая проза",
        url: "/legkoe-chtenie/legkaya_proza/",
        arts_count: 2631,
      },
      {
        id: 5017,
        uuid: "ed16029c-f034-11e5-a511-0cc47a5454c6",
        name: "ужасы / мистика",
        url: "/knigi-uzhasy-mistika/",
        arts_count: 22159,
      },
      {
        id: 5001,
        uuid: "ed15f322-f034-11e5-a511-0cc47a5454c6",
        name: "комиксы / манга",
        url: "/komiksy-manga/",
        arts_count: 1756,
      },
    ],
  },
  {
    id: 201591,
    uuid: "89750dad-db67-11e7-8020-0cc47a545a1e",
    name: "серьезное чтение",
    url: "/sereznoe-chtenie/",
    arts_count: 273583,
    subgenres: [
      {
        id: 5015,
        uuid: "ed1600a4-f034-11e5-a511-0cc47a5454c6",
        name: "современная проза",
        url: "/knigi-sovremennaya-proza/",
        arts_count: 133267,
      },
      {
        id: 5028,
        uuid: "ed160c02-f034-11e5-a511-0cc47a5454c6",
        name: "классическая литература",
        url: "/klassicheskaya-literatura/",
        arts_count: 68759,
      },
      {
        id: 201719,
        uuid: "8979faaa-db67-11e7-8020-0cc47a545a1e",
        name: "об истории серьезно",
        url: "/sereznoe-chtenie/ob-istorii-serezno/",
        arts_count: 55203,
      },
      {
        id: 5169,
        uuid: "ed16ef1c-f034-11e5-a511-0cc47a5454c6",
        name: "биографии и мемуары",
        url: "/knigi-publicistika/biografii-memuary/",
        arts_count: 23000,
      },
      {
        id: 201711,
        uuid: "89799776-db67-11e7-8020-0cc47a545a1e",
        name: "cтихи, поэзия",
        url: "/sereznoe-chtenie/stihi-poeziya/",
        arts_count: 27600,
      },
      {
        id: 201695,
        uuid: "8978f8c0-db67-11e7-8020-0cc47a545a1e",
        name: "пьесы, драматургия",
        url: "/sereznoe-chtenie/pesy-dramaturgiya/",
        arts_count: 5981,
      },
    ],
  },
  {
    id: 201599,
    uuid: "897551b1-db67-11e7-8020-0cc47a545a1e",
    name: "история",
    url: "/istoriya/",
    arts_count: 102102,
    subgenres: [
      {
        id: 201727,
        uuid: "897a5397-db67-11e7-8020-0cc47a545a1e",
        name: "популярно об истории",
        url: "/populyarno-ob-istorii/",
        arts_count: 8601,
        subgenres: [],
      },
      {
        id: 5094,
        uuid: "ed167260-f034-11e5-a511-0cc47a5454c6",
        name: "книги о путешествиях",
        url: "/knigi-priklucheniya/puteshestviyah/",
        arts_count: 10014,
        subgenres: [],
      },
      {
        id: 5169,
        uuid: "ed16ef1c-f034-11e5-a511-0cc47a5454c6",
        name: "биографии и мемуары",
        url: "/knigi-publicistika/biografii-memuary/",
        arts_count: 23000,
        subgenres: [],
      },
      {
        id: 5258,
        uuid: "ed177264-f034-11e5-a511-0cc47a5454c6",
        name: "исторические детективы",
        url: "/knigi-detektivy/istoricheskie/",
        arts_count: 2413,
        subgenres: [],
      },
      {
        id: 5209,
        uuid: "ed173a66-f034-11e5-a511-0cc47a5454c6",
        name: "историческая литература",
        url: "/knigi-sovremennaya-proza/istoricheskaya-literatura/",
        arts_count: 16306,
        subgenres: [],
      },
      {
        id: 5095,
        uuid: "ed167372-f034-11e5-a511-0cc47a5454c6",
        name: "исторические приключения",
        url: "/knigi-priklucheniya/istoricheskie/",
        arts_count: 6653,
        subgenres: [],
      },
      {
        id: 5071,
        uuid: "ed163cdf-f034-11e5-a511-0cc47a5454c6",
        name: "историческая фантастика",
        url: "/knigi-fantastika/istoricheskaya/",
        arts_count: 6347,
        subgenres: [],
      },
      {
        id: 5227,
        uuid: "ed174fb3-f034-11e5-a511-0cc47a5454c6",
        name: "историческое фэнтези",
        url: "/knigi-fentezi/istoricheskoe/",
        arts_count: 3602,
        subgenres: [],
      },
      {
        id: 5170,
        uuid: "ed16f080-f034-11e5-a511-0cc47a5454c6",
        name: "документальная литература",
        url: "/knigi-publicistika/dokumentalnaya-literatura/",
        arts_count: 33939,
        subgenres: [],
      },
      {
        id: 5205,
        uuid: "ed1736eb-f034-11e5-a511-0cc47a5454c6",
        name: "книги о войне",
        url: "/knigi-sovremennaya-proza/knigi_o_voyne/",
        arts_count: 4443,
        subgenres: [],
      },
      {
        id: 5092,
        uuid: "ed16678b-f034-11e5-a511-0cc47a5454c6",
        name: "морские приключения",
        url: "/knigi-priklucheniya/morskie/",
        arts_count: 1695,
        subgenres: [],
      },
      {
        id: 5087,
        uuid: "ed165894-f034-11e5-a511-0cc47a5454c6",
        name: "исторические любовные романы",
        url: "/knigi-lubovnye-romany/istoricheskiye/",
        arts_count: 7979,
        subgenres: [],
      },
    ],
  },
  {
    id: 5003,
    uuid: "ed15f4ee-f034-11e5-a511-0cc47a5454c6",
    name: "бизнес-книги",
    url: "/znaniya-navyki/biznes/",
    arts_count: 64109,

    subgenres: [
      {
        id: 5064,
        uuid: "ed162e62-f034-11e5-a511-0cc47a5454c6",
        name: "личная эффективность",
        url: "/biznes-knigi/lichnaya-effektivnost/",
        arts_count: 4996,
        subgenres: [],
      },
      {
        id: 5070,
        uuid: "ed163bfc-f034-11e5-a511-0cc47a5454c6",
        name: "менеджмент",
        url: "/biznes-knigi/menedzhment/",
        arts_count: 9563,
      },
      {
        id: 5058,
        uuid: "ed1628c6-f034-11e5-a511-0cc47a5454c6",
        name: "о бизнесе популярно",
        url: "/biznes-knigi/o-biznese-populyarno/",
        arts_count: 11950,
      },
      {
        id: 5061,
        uuid: "ed162b99-f034-11e5-a511-0cc47a5454c6",
        name: "зарубежная деловая литература",
        url: "/biznes-knigi/zarubezhnaya-delovaya-literatura/",
        arts_count: 12737,

        subgenres: [],
      },
      {
        id: 5065,
        uuid: "ed162f28-f034-11e5-a511-0cc47a5454c6",
        name: "тайм-менеджмент",
        url: "/biznes-knigi/taym-menedzhment/",
        arts_count: 511,
        subgenres: [],
      },
      {
        id: 5052,
        uuid: "ed162353-f034-11e5-a511-0cc47a5454c6",
        name: "экономика",
        url: "/knigi-nauka-obrazovanie/ekonomika/",
        arts_count: 20718,
      },
      {
        id: 5047,
        uuid: "ed161eb5-f034-11e5-a511-0cc47a5454c6",
        name: "кадровый менеджмент",
        url: "/biznes-knigi/kadrovyj_menedzhment/",
        arts_count: 3535,
      },
      {
        id: 5050,
        uuid: "ed16217b-f034-11e5-a511-0cc47a5454c6",
        name: "ценные бумаги / инвестиции",
        url: "/biznes-knigi/cennye-bumagi-investicii/",
        arts_count: 2403,
        subgenres: [],
      },
      {
        id: 5068,
        uuid: "ed1639ac-f034-11e5-a511-0cc47a5454c6",
        name: "стартапы и создание бизнеса",
        url: "/biznes-knigi/startapy/",
        arts_count: 4148,
        subgenres: [],
      },
      {
        id: 5054,
        uuid: "ed162508-f034-11e5-a511-0cc47a5454c6",
        name: "отраслевые издания",
        url: "/biznes-knigi/otraslevye-izdaniya/",
        arts_count: 3389,
        subgenres: [],
      },
      {
        id: 5053,
        uuid: "ed16242c-f034-11e5-a511-0cc47a5454c6",
        name: "финансы",
        url: "/biznes-knigi/finansy/",
        arts_count: 3089,
      },
      {
        id: 5056,
        uuid: "ed162716-f034-11e5-a511-0cc47a5454c6",
        name: "личные финансы",
        url: "/biznes-knigi/lichnye-finansy/",
        arts_count: 2858,

        subgenres: [],
      },
      {
        id: 5048,
        uuid: "ed161f90-f034-11e5-a511-0cc47a5454c6",
        name: "маркетинг, PR, реклама",
        url: "/biznes-knigi/marketing-pr-reklama/",
        arts_count: 3849,
      },
      {
        id: 5062,
        uuid: "ed162cc8-f034-11e5-a511-0cc47a5454c6",
        name: "интернет-бизнес",
        url: "/biznes-knigi/internet/",
        arts_count: 2124,

        subgenres: [],
      },
      {
        id: 6462,
        uuid: "ed1b282e-f034-11e5-a511-0cc47a5454c6",
        name: "менеджмент и кадры",
        url: "/biznes-knigi/management_kadry_old/",
        arts_count: 2874,
        subgenres: [],
      },
      {
        id: 5063,
        uuid: "ed162d99-f034-11e5-a511-0cc47a5454c6",
        name: "продажи",
        url: "/biznes-knigi/prodazhi/",
        arts_count: 1243,
      },
      {
        id: 5059,
        uuid: "ed1629b0-f034-11e5-a511-0cc47a5454c6",
        name: "малый и средний бизнес",
        url: "/biznes-knigi/malyy-biznes/",
        arts_count: 3170,

        subgenres: [],
      },
      {
        id: 5066,
        uuid: "ed162ffa-f034-11e5-a511-0cc47a5454c6",
        name: "ораторское искусство / риторика",
        url: "/biznes-knigi/oratorskoye-iskusstvo/",
        arts_count: 577,
        subgenres: [],
      },
      {
        id: 5055,
        uuid: "ed162603-f034-11e5-a511-0cc47a5454c6",
        name: "корпоративная культура",
        url: "/biznes-knigi/korporativnaya-kultura/",
        arts_count: 610,

        subgenres: [],
      },
      {
        id: 5067,
        uuid: "ed1630c2-f034-11e5-a511-0cc47a5454c6",
        name: "переговоры",
        url: "/biznes-knigi/peregovory/",
        arts_count: 686,
        subgenres: [],
      },
      {
        id: 5069,
        uuid: "ed163b06-f034-11e5-a511-0cc47a5454c6",
        name: "работа с клиентами",
        url: "/biznes-knigi/kliyenty/",
        arts_count: 362,

        subgenres: [],
      },
      {
        id: 6784,
        uuid: "ed1b9334-f034-11e5-a511-0cc47a5454c6",
        name: "государственное и муниципальное управление",
        url: "/biznes-knigi/gosudarstvennoe-i-munitsipalnoe-upravlenie/",
        arts_count: 1189,

        subgenres: [],
      },
      {
        id: 5046,
        uuid: "ed161dcc-f034-11e5-a511-0cc47a5454c6",
        name: "поиск работы / карьера",
        url: "/biznes-knigi/poisk-raboty-karera/",
        arts_count: 2166,
        subgenres: [],
      },
      {
        id: 201413,
        uuid: "e8aacf76-d8e2-11e7-af8e-0cc47a1952f2",
        name: "краткое содержание",
        url: "/biznes-knigi/kratkoe-soderzhanie/",
        arts_count: 1636,
      },
      {
        id: 5051,
        uuid: "ed162257-f034-11e5-a511-0cc47a5454c6",
        name: "бухучет / налогообложение / аудит",
        url: "/biznes-knigi/buhuchet-nalogooblozhenie-audit/",
        arts_count: 2430,
        subgenres: [],
      },
      {
        id: 210646,
        uuid: "c2595510-802e-11e8-afe9-0cc47a5453d6",
        name: "бизнес-справочники",
        url: "/spravochniki-slovari/spravochniki/business-spravochniki/",
        arts_count: 30,
        subgenres: [],
      },
      {
        id: 5049,
        uuid: "ed162096-f034-11e5-a511-0cc47a5454c6",
        name: "банковское дело",
        url: "/biznes-knigi/bankovskoe-delo/",
        arts_count: 1121,
        subgenres: [],
      },
      {
        id: 5060,
        uuid: "ed162a83-f034-11e5-a511-0cc47a5454c6",
        name: "делопроизводство",
        url: "/biznes-knigi/deloproizvodstvo/",
        arts_count: 285,
        subgenres: [],
      },
      {
        id: 5057,
        uuid: "ed1627f4-f034-11e5-a511-0cc47a5454c6",
        name: "недвижимость",
        url: "/biznes-knigi/nedvizhimost/",
        arts_count: 1944,
        subgenres: [],
      },
      {
        id: 5375,
        uuid: "ed181956-f034-11e5-a511-0cc47a5454c6",
        name: "логистика",
        url: "/biznes-knigi/logistika/",
        arts_count: 793,

        subgenres: [],
      },
      {
        id: 6810,
        uuid: "ed1b9cfa-f034-11e5-a511-0cc47a5454c6",
        name: "политическое управление",
        url: "/biznes-knigi/piliticheskoe-upravlenie/",
        arts_count: 742,

        subgenres: [],
      },
    ],
  },
  {
    id: 201623,
    uuid: "8976184d-db67-11e7-8020-0cc47a545a1e",
    name: "знания и навыки",
    url: "/znaniya-navyki/",
    arts_count: 383432,

    subgenres: [
      {
        id: 5253,
        uuid: "ed176dc5-f034-11e5-a511-0cc47a5454c6",
        name: "саморазвитие / личностный рост",
        url: "/knigi-psihologiya/samorazvitiye-lichnostnyy-rost/",
        arts_count: 22002,
        subgenres: [],
      },
      {
        id: 5031,
        uuid: "ed160f04-f034-11e5-a511-0cc47a5454c6",
        name: "научно-популярная литература",
        url: "/knigi-nauka-obrazovanie/nauchno-populyarnaya-literatura/",
        arts_count: 16781,

        subgenres: [],
      },
      {
        id: 5030,
        uuid: "ed160e36-f034-11e5-a511-0cc47a5454c6",
        name: "учебная и научная литература",
        url: "/znaniya-navyki/uchebnaya-nauchnaya-literatura/",
        arts_count: 298809,
      },
      {
        id: 5003,
        uuid: "ed15f4ee-f034-11e5-a511-0cc47a5454c6",
        name: "бизнес-книги",
        url: "/znaniya-navyki/biznes/",
        arts_count: 64109,
      },
      {
        id: 53055,
        uuid: "612793ba-5b5b-11e4-96e2-0025905a06ea",
        name: "истории из жизни",
        url: "/psihologiya-motivaciya/istorii-iz-zhizni/",
        arts_count: 9652,

        subgenres: [],
      },
      {
        id: 5011,
        uuid: "ed15fc8e-f034-11e5-a511-0cc47a5454c6",
        name: "эзотерика",
        url: "/knigi-ezoterika/",
        arts_count: 17207,
      },
      {
        id: 5009,
        uuid: "ed15fa46-f034-11e5-a511-0cc47a5454c6",
        name: "словари, справочники",
        url: "/spravochniki-slovari/",
        arts_count: 25323,
      },
      {
        id: 201639,
        uuid: "8976bba3-db67-11e7-8020-0cc47a545a1e",
        name: "хобби, досуг",
        url: "/hobbi-dosug/",
        arts_count: 65491,
      },
      {
        id: 5024,
        uuid: "ed16087a-f034-11e5-a511-0cc47a5454c6",
        name: "компьютерная литература",
        url: "/kompyuternaya-literatura/",
        arts_count: 12578,
      },
      {
        id: 5020,
        uuid: "ed160503-f034-11e5-a511-0cc47a5454c6",
        name: "культура и искусство",
        url: "/knigi-iskusstvo/",
        arts_count: 47222,
      },
      {
        id: 6356,
        uuid: "ed1af4aa-f034-11e5-a511-0cc47a5454c6",
        name: "изучение языков",
        url: "/znaniya-navyki/uchebnaya-nauchnaya-literatura/gumanitarnye-obschestvennye-nauki/izuchenie-yazykov/",
        arts_count: 9503,
      },
      {
        id: 5163,
        uuid: "ed16b8ef-f034-11e5-a511-0cc47a5454c6",
        name: "путеводители",
        url: "/spravochniki-slovari/putevoditeli/",
        arts_count: 2939,

        subgenres: [],
      },
    ],
  },
  {
    id: 201631,
    uuid: "89765633-db67-11e7-8020-0cc47a545a1e",
    name: "психология, мотивация",
    url: "/psihologiya-motivaciya/",
    arts_count: 137110,

    subgenres: [
      {
        id: 5021,
        uuid: "ed1605d0-f034-11e5-a511-0cc47a5454c6",
        name: "книги по психологии",
        url: "/knigi-psihologiya/",
        arts_count: 43084,
      },
      {
        id: 5253,
        uuid: "ed176dc5-f034-11e5-a511-0cc47a5454c6",
        name: "саморазвитие / личностный рост",
        url: "/knigi-psihologiya/samorazvitiye-lichnostnyy-rost/",
        arts_count: 22002,
        subgenres: [],
      },
      {
        id: 5012,
        uuid: "ed15fd62-f034-11e5-a511-0cc47a5454c6",
        name: "религия и духовная литература",
        url: "/psihologiya-motivaciya/religiya-duhovnaya-literatura/",
        arts_count: 15439,
      },
      {
        id: 5169,
        uuid: "ed16ef1c-f034-11e5-a511-0cc47a5454c6",
        name: "биографии и мемуары",
        url: "/knigi-publicistika/biografii-memuary/",
        arts_count: 23000,

        subgenres: [],
      },
      {
        id: 53055,
        uuid: "612793ba-5b5b-11e4-96e2-0025905a06ea",
        name: "истории из жизни",
        url: "/psihologiya-motivaciya/istorii-iz-zhizni/",
        arts_count: 9652,

        subgenres: [],
      },
      {
        id: 5011,
        uuid: "ed15fc8e-f034-11e5-a511-0cc47a5454c6",
        name: "эзотерика",
        url: "/knigi-ezoterika/",
        arts_count: 17207,
      },
      {
        id: 5020,
        uuid: "ed160503-f034-11e5-a511-0cc47a5454c6",
        name: "культура и искусство",
        url: "/knigi-iskusstvo/",
        arts_count: 47222,
      },
    ],
  },
  {
    id: 201615,
    uuid: "8975d10c-db67-11e7-8020-0cc47a545a1e",
    name: "спорт, здоровье, красота",
    url: "/sport-zdorove-krasota/",
    arts_count: 26786,

    subgenres: [
      {
        id: 201743,
        uuid: "897aff02-db67-11e7-8020-0cc47a545a1e",
        name: "медицина и здоровье",
        url: "/sport-zdorove-krasota/medicina-i-zdorove/",
        arts_count: 18307,
      },
      {
        id: 201759,
        uuid: "897b914e-db67-11e7-8020-0cc47a545a1e",
        name: "спорт",
        url: "/sport-zdorove-krasota/sport/",
        arts_count: 6898,
      },
      {
        id: 5310,
        uuid: "ed17c045-f034-11e5-a511-0cc47a5454c6",
        name: "секс / секс-руководства",
        url: "/erotika-seks/seksualnyye-rukovodstva/",
        arts_count: 1534,

        subgenres: [],
      },
      {
        id: 201767,
        uuid: "897bdcc0-db67-11e7-8020-0cc47a545a1e",
        name: "красота",
        url: "/sport-zdorove-krasota/krasota/",
        arts_count: 2111,
      },
    ],
  },
  {
    id: 201639,
    uuid: "8976bba3-db67-11e7-8020-0cc47a545a1e",
    name: "хобби, досуг",
    url: "/hobbi-dosug/",
    arts_count: 65491,

    subgenres: [
      {
        id: 5179,
        uuid: "ed16ff73-f034-11e5-a511-0cc47a5454c6",
        name: "йога",
        url: "/knigi-ezoterika/yoga/",
        arts_count: 1025,

        subgenres: [],
      },
      {
        id: 5275,
        uuid: "ed1782c4-f034-11e5-a511-0cc47a5454c6",
        name: "кулинария",
        url: "/knigi-dom-semya/kulinariya/",
        arts_count: 6088,

        subgenres: [],
      },
      {
        id: 5287,
        uuid: "ed1790c9-f034-11e5-a511-0cc47a5454c6",
        name: "хобби / увлечения",
        url: "/knigi-dom-semya/hobbi_uvlecheniya/",
        arts_count: 7750,

        subgenres: [],
      },
      {
        id: 5236,
        uuid: "ed175b58-f034-11e5-a511-0cc47a5454c6",
        name: "изобразительное искусство",
        url: "/knigi-iskusstvo/izobrazitelnoe-iskusstvo/",
        arts_count: 12005,

        subgenres: [],
      },
      {
        id: 5280,
        uuid: "ed17899d-f034-11e5-a511-0cc47a5454c6",
        name: "рукоделие и ремесла",
        url: "/knigi-dom-semya/rukodeliye-remesla/",
        arts_count: 7689,

        subgenres: [],
      },
      {
        id: 5278,
        uuid: "ed178550-f034-11e5-a511-0cc47a5454c6",
        name: "спорт / фитнес",
        url: "/knigi-krasota-zdorove/sport-fitnes/",
        arts_count: 6497,

        subgenres: [],
      },
      {
        id: 5285,
        uuid: "ed178ea0-f034-11e5-a511-0cc47a5454c6",
        name: "мода и стиль",
        url: "/knigi-dom-semya/moda-stil/",
        arts_count: 2017,

        subgenres: [],
      },
      {
        id: 5276,
        uuid: "ed1783a5-f034-11e5-a511-0cc47a5454c6",
        name: "сделай сам",
        url: "/knigi-dom-semya/sdelay-sam/",
        arts_count: 17983,

        subgenres: [],
      },
      {
        id: 5216,
        uuid: "ed17418b-f034-11e5-a511-0cc47a5454c6",
        name: "прикладная литература",
        url: "/knigi-dom-semya/prikladnaya-literatura/",
        arts_count: 4130,

        subgenres: [],
      },
      {
        id: 5282,
        uuid: "ed178c0e-f034-11e5-a511-0cc47a5454c6",
        name: "сад и огород",
        url: "/knigi-dom-semya/sad-ogorod/",
        arts_count: 2278,

        subgenres: [],
      },
      {
        id: 5274,
        uuid: "ed1781d3-f034-11e5-a511-0cc47a5454c6",
        name: "природа и животные",
        url: "/knigi-dom-semya/priroda_i_zhivotnye/",
        arts_count: 2843,

        subgenres: [],
      },
      {
        id: 5289,
        uuid: "ed17998c-f034-11e5-a511-0cc47a5454c6",
        name: "отдых / туризм",
        url: "/knigi-dom-semya/otdykh-turizm/",
        arts_count: 2418,

        subgenres: [],
      },
      {
        id: 5237,
        uuid: "ed175c77-f034-11e5-a511-0cc47a5454c6",
        name: "искусство фотографии",
        url: "/knigi-iskusstvo/fotografiya/",
        arts_count: 299,

        subgenres: [],
      },
      {
        id: 209790,
        uuid: "defb0258-77b8-11e8-b0db-0cc47a52085c",
        name: "интеллектуальные игры",
        url: "/intellektualnye-igry/",
        arts_count: 262,

        subgenres: [],
      },
      {
        id: 5163,
        uuid: "ed16b8ef-f034-11e5-a511-0cc47a5454c6",
        name: "путеводители",
        url: "/spravochniki-slovari/putevoditeli/",
        arts_count: 2939,

        subgenres: [],
      },
      {
        id: 5281,
        uuid: "ed178b06-f034-11e5-a511-0cc47a5454c6",
        name: "развлечения",
        url: "/knigi-dom-semya/razvlecheniya/",
        arts_count: 9594,

        subgenres: [],
      },
      {
        id: 5283,
        uuid: "ed178cff-f034-11e5-a511-0cc47a5454c6",
        name: "автомобили и ПДД",
        url: "/knigi-dom-semya/pdd-koap-shtrafy/",
        arts_count: 6449,
        subgenres: [],
      },
      {
        id: 6825,
        uuid: "ed1ba2ce-f034-11e5-a511-0cc47a5454c6",
        name: "рыбалка",
        url: "/knigi-dom-semya/rybalka/",
        arts_count: 173,

        subgenres: [],
      },
      {
        id: 5286,
        uuid: "ed178f99-f034-11e5-a511-0cc47a5454c6",
        name: "охота",
        url: "/knigi-dom-semya/ohota/",
        arts_count: 158,

        subgenres: [],
      },
    ],
  },
  {
    id: 201647,
    uuid: "8976fd1b-db67-11e7-8020-0cc47a545a1e",
    name: "дом, дача",
    url: "/dom-dacha/",
    arts_count: 39672,

    subgenres: [
      {
        id: 5275,
        uuid: "ed1782c4-f034-11e5-a511-0cc47a5454c6",
        name: "кулинария",
        url: "/knigi-dom-semya/kulinariya/",
        arts_count: 6088,

        subgenres: [],
      },
      {
        id: 5287,
        uuid: "ed1790c9-f034-11e5-a511-0cc47a5454c6",
        name: "хобби / увлечения",
        url: "/knigi-dom-semya/hobbi_uvlecheniya/",
        arts_count: 7750,

        subgenres: [],
      },
      {
        id: 201807,
        uuid: "897ef962-db67-11e7-8020-0cc47a545a1e",
        name: "домашнее хозяйство",
        url: "/dom-dacha/domashnee-hozyaystvo/",
        arts_count: 820,

        subgenres: [],
      },
      {
        id: 5280,
        uuid: "ed17899d-f034-11e5-a511-0cc47a5454c6",
        name: "рукоделие и ремесла",
        url: "/knigi-dom-semya/rukodeliye-remesla/",
        arts_count: 7689,

        subgenres: [],
      },
      {
        id: 5279,
        uuid: "ed178633-f034-11e5-a511-0cc47a5454c6",
        name: "домашние животные",
        url: "/knigi-dom-semya/domashnie-zhivotnye/",
        arts_count: 1335,

        subgenres: [],
      },
      {
        id: 5276,
        uuid: "ed1783a5-f034-11e5-a511-0cc47a5454c6",
        name: "сделай сам",
        url: "/knigi-dom-semya/sdelay-sam/",
        arts_count: 17983,

        subgenres: [],
      },
      {
        id: 5282,
        uuid: "ed178c0e-f034-11e5-a511-0cc47a5454c6",
        name: "сад и огород",
        url: "/knigi-dom-semya/sad-ogorod/",
        arts_count: 2278,

        subgenres: [],
      },
      {
        id: 5274,
        uuid: "ed1781d3-f034-11e5-a511-0cc47a5454c6",
        name: "природа и животные",
        url: "/knigi-dom-semya/priroda_i_zhivotnye/",
        arts_count: 2843,

        subgenres: [],
      },
      {
        id: 5288,
        uuid: "ed179191-f034-11e5-a511-0cc47a5454c6",
        name: "интерьеры",
        url: "/knigi-dom-semya/interyery/",
        arts_count: 476,

        subgenres: [],
      },
      {
        id: 5289,
        uuid: "ed17998c-f034-11e5-a511-0cc47a5454c6",
        name: "отдых / туризм",
        url: "/knigi-dom-semya/otdykh-turizm/",
        arts_count: 2418,

        subgenres: [],
      },
      {
        id: 5187,
        uuid: "ed170d0e-f034-11e5-a511-0cc47a5454c6",
        name: "фэншуй / фэн-шуй",
        url: "/knigi-ezoterika/fen-shuy/",
        arts_count: 201,

        subgenres: [],
      },
      {
        id: 5283,
        uuid: "ed178cff-f034-11e5-a511-0cc47a5454c6",
        name: "автомобили и ПДД",
        url: "/knigi-dom-semya/pdd-koap-shtrafy/",
        arts_count: 6449,
        subgenres: [],
      },
      {
        id: 201815,
        uuid: "897f3f86-db67-11e7-8020-0cc47a545a1e",
        name: "ремонт в квартире",
        url: "/dom-dacha/remont-v-kvartire/",
        arts_count: 301,

        subgenres: [],
      },
      {
        id: 201799,
        uuid: "897e6587-db67-11e7-8020-0cc47a545a1e",
        name: "комнатные растения",
        url: "/dom-dacha/komnatnye-rasteniya/",
        arts_count: 51,

        subgenres: [],
      },
      {
        id: 6825,
        uuid: "ed1ba2ce-f034-11e5-a511-0cc47a5454c6",
        name: "рыбалка",
        url: "/knigi-dom-semya/rybalka/",
        arts_count: 173,

        subgenres: [],
      },
      {
        id: 5286,
        uuid: "ed178f99-f034-11e5-a511-0cc47a5454c6",
        name: "охота",
        url: "/knigi-dom-semya/ohota/",
        arts_count: 158,

        subgenres: [],
      },
    ],
  },
  {
    id: 5007,
    uuid: "ed15f858-f034-11e5-a511-0cc47a5454c6",
    name: "детские книги",
    url: "/detskie-knigi/",
    arts_count: 75358,

    subgenres: [
      {
        id: 5111,
        uuid: "ed167d94-f034-11e5-a511-0cc47a5454c6",
        name: "зарубежные детские книги",
        url: "/detskie-knigi/zarubezhnye/",
        arts_count: 7060,
        subgenres: [],
      },
      {
        id: 5106,
        uuid: "ed1678fc-f034-11e5-a511-0cc47a5454c6",
        name: "сказки",
        url: "/detskie-knigi/skazki/",
        arts_count: 14943,

        subgenres: [],
      },
      {
        id: 6517,
        uuid: "ed1b4896-f034-11e5-a511-0cc47a5454c6",
        name: "книги для детей",
        url: "/detskie-knigi/children/",
        arts_count: 12213,

        subgenres: [],
      },
      {
        id: 6610,
        uuid: "ed1b688b-f034-11e5-a511-0cc47a5454c6",
        name: "книги для дошкольников",
        url: "/detskie-knigi/knigi_doshkolniki/",
        arts_count: 3021,

        subgenres: [],
      },
      {
        id: 5105,
        uuid: "ed167830-f034-11e5-a511-0cc47a5454c6",
        name: "книги для подростков",
        url: "/detskie-knigi/dlya-podrostkov/",
        arts_count: 5338,
        subgenres: [],
      },
      {
        id: 5104,
        uuid: "ed167748-f034-11e5-a511-0cc47a5454c6",
        name: "детская проза",
        url: "/detskie-knigi/proza/",
        arts_count: 8396,
        subgenres: [],
      },
      {
        id: 5108,
        uuid: "ed167b0e-f034-11e5-a511-0cc47a5454c6",
        name: "детская фантастика",
        url: "/detskie-knigi/fantastika/",
        arts_count: 4536,

        subgenres: [],
      },
      {
        id: 5107,
        uuid: "ed167a17-f034-11e5-a511-0cc47a5454c6",
        name: "детские приключения",
        url: "/detskie-knigi/priklucheniya/",
        arts_count: 7938,

        subgenres: [],
      },
      {
        id: 5008,
        uuid: "ed15f952-f034-11e5-a511-0cc47a5454c6",
        name: "школьные учебники",
        url: "/shkolnye-uchebniki/",
        arts_count: 6505,
      },
      {
        id: 5109,
        uuid: "ed167be2-f034-11e5-a511-0cc47a5454c6",
        name: "детские детективы",
        url: "/detskie-knigi/detektivy/",
        arts_count: 1837,

        subgenres: [],
      },
      {
        id: 5110,
        uuid: "ed167caf-f034-11e5-a511-0cc47a5454c6",
        name: "детские стихи",
        url: "/detskie-knigi/stihi/",
        arts_count: 2547,
        subgenres: [],
      },
      {
        id: 6481,
        uuid: "ed1b3ee2-f034-11e5-a511-0cc47a5454c6",
        name: "детская познавательная и развивающая литература",
        url: "/detskie-knigi/detskaya_pazvivayushaya_literatura/",
        arts_count: 18420,

        subgenres: [],
      },
      {
        id: 5103,
        uuid: "ed16764b-f034-11e5-a511-0cc47a5454c6",
        name: "учебная литература",
        url: "/detskie-knigi/uchebnaya-literatura/",
        arts_count: 10944,

        subgenres: [],
      },
      {
        id: 5102,
        uuid: "ed167547-f034-11e5-a511-0cc47a5454c6",
        name: "внеклассное чтение",
        url: "/detskie-knigi/vneklassnoye-chteniye/",
        arts_count: 6674,
        subgenres: [],
      },
      {
        id: 5313,
        uuid: "ed17ca44-f034-11e5-a511-0cc47a5454c6",
        name: "буквари",
        url: "/detskie-knigi/bukvari/",
        arts_count: 193,

        subgenres: [],
      },
    ],
  },
  {
    id: 201607,
    uuid: "89759926-db67-11e7-8020-0cc47a545a1e",
    name: "родителям",
    url: "/roditelyam/",
    arts_count: 6450,

    subgenres: [
      {
        id: 5284,
        uuid: "ed178dce-f034-11e5-a511-0cc47a5454c6",
        name: "воспитание детей",
        url: "/knigi-dom-semya/vospitanie-detey/",
        arts_count: 6771,

        subgenres: [],
      },
      {
        id: 5254,
        uuid: "ed176e9c-f034-11e5-a511-0cc47a5454c6",
        name: "детская психология",
        url: "/knigi-psihologiya/detskaya/",
        arts_count: 3330,

        subgenres: [],
      },
      {
        id: 5007,
        uuid: "ed15f858-f034-11e5-a511-0cc47a5454c6",
        name: "детские книги",
        url: "/detskie-knigi/",
        arts_count: 75358,
      },
      {
        id: 201735,
        uuid: "897aadcd-db67-11e7-8020-0cc47a545a1e",
        name: "здоровье детей",
        url: "/zdorovye-detey/",
        arts_count: 822,

        subgenres: [],
      },
    ],
  },
  {
    id: 201655,
    uuid: "89774107-db67-11e7-8020-0cc47a545a1e",
    name: "публицистика и периодические издания",
    url: "/publicistika-periodicheskie-izdaniya/",
    arts_count: 138929,

    subgenres: [
      {
        id: 5010,
        uuid: "ed15fb9a-f034-11e5-a511-0cc47a5454c6",
        name: "публицистическая литература",
        url: "/knigi-publicisticheskaya-literatura/",
        arts_count: 86331,
      },
      {
        id: 5027,
        uuid: "ed160b2d-f034-11e5-a511-0cc47a5454c6",
        name: "периодические издания",
        url: "/periodicheskie-izdaniya/",
        arts_count: 37909,
      },
      {
        id: 135475,
        uuid: "6177e58a-5b5b-11e4-96e2-0025905a06ea",
        name: "подкасты",
        url: "/podcasts/",
        arts_count: 32630,
      },
    ],
  },
];

export const genreDeclination = ["поджанр", "поджанра", "поджанров"];
